import Vue from 'vue';
import batchTransformer from '../../transformers/batch';

const success = (resolve, response) => {
  resolve(batchTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  reject(batchTransformer.fetch(errors));
};

export default batch => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/production/batch', batch)
      .then((response) => {
        success(resolve, response.data);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batch/store.js